import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";

export const getMonitorsLegth = (state: ReducerFromState<MonitorReducer>): number => state.monitor.monitors.length;
